import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import chevronLeft from "../assets/fi_chevron-left.svg";
import roadIcon from "../assets/fi_road.svg";
import clockIcon from "../assets/fi_clock.svg";
import downloadIcon from "../assets/fi_download.svg";
import PageLabel from "./PageLabel";
import Address from "./Address";
import RideDetailsLine from "./RideDetailsLine";
import BaseButton from "./BaseButton";
import Loader from "./Loader";
import { downloadInvoice } from "../services/_downloadInvoice";
import InvoiceNotice from "./InvoiceNotice";
import backendApi from '../services/backendApi';

const RideDetails = () => {
    const { encodedId } = useParams();
    const { login, user } = useAuth();

    const [ride, setRide] = useState(null);
    const [error, setError] = useState(null);
    const [invoiceProps, setInvoiceProps] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isDownloading, setIsDownloading] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();
    const fromRideHistory = location.state?.fromRideHistory;

    const handleDownload = async (encodedId) => {
        try {
            setIsDownloading(true);
            await downloadInvoice(encodedId);
        } catch (err) {
            console.error("Download failed", err);
        } finally {
            setIsDownloading(false);
        }
    };

    useEffect(() => {

        if (!encodedId) return;

        const fetchRide = async () => {
            try {
                const response = await backendApi.get(`/api/ride/${encodedId}`);

                if (response.status != 200) {
                    throw new Error('Failed to fetch ride');
                }

                const data = response.data;

                setRide(data.ride);

                if (!fromRideHistory) {
                    const clientProfileResponse = await backendApi.get('/api/get-user-profile');

                    if (clientProfileResponse.status == 200) {
                        const userData = clientProfileResponse.data;

                        if (userData && userData.client) {
                            login(userData.client);
                        }

                        if (userData && userData.invoiceProps) {
                            setInvoiceProps(userData.invoiceProps);
                        }
                    } else {
                        console.warn('User not logged in or token invalid');
                    }
                }

                if (data.ride.isActive) {
                    navigate('/order');
                }

            } catch (err) {
                console.error(err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchRide();
    }, [encodedId, login]);


    if (isDownloading) return <Loader />;
    if (loading) return <Loader />;
    if (error) return <p style={{ color: 'red' }}>Error: {error}</p>;
    if (!ride) return <p>Užsakymas nerastas</p>;

    return (
        <div className="rideDetails pageContent">
            <PageLabel
                text={ride.createdOn}
                className="pageLabel__navBack"
                icon={
                    <img
                        className="iconLeft"
                        src={chevronLeft}
                        alt=""
                        loading="lazy"
                        onClick={() => navigate('/history')}
                        style={{ cursor: 'pointer', height: '24px' }}
                    />
                }
            />

            <div className="rideDetails__content">
                <div className="rideDetails__route rideDetails--statistics rideDetails__section">
                    <div className="rideDetails__number">
                        <img src={roadIcon} alt="" loading="lazy" />
                        {ride.distance} km
                    </div>
                    <div className="rideDetails__number">
                        <img src={clockIcon} alt="" loading="lazy" />
                        {ride.duration}
                    </div>
                </div>
                <div className="rideDetails__route rideDetails__section rideDetails__section--border">
                    <Address
                        time={ride.startTime}
                        address={ride.from}
                    />
                    <Address
                        time={ride.endTime}
                        address={ride.to}
                        isLast={true}
                    />
                </div>
                <div className="rideDetails__payment rideDetails__section rideDetails__section--border ">
                    <RideDetailsLine text={'Kaina'} value={ride.price + '€'} />
                    {ride?.companyPays && <RideDetailsLine text={'Įmonės lėšomis'} value={ride.companyPays + '€'} />}
                    {ride?.eTransportPayment && <RideDetailsLine text={'Panaudoti ETRANSPORT pinigai'} value={ride.eTransportPayment + '€'} />}
                    {ride?.clientPayment > 0 && (
                        <RideDetailsLine
                            text={`Sumokėta suma (${ride.paymentMethod})`}
                            value={`${ride.clientPayment}€`}
                        />
                    )}
                </div>
                <div className="rideDetails__driver rideDetails__section">
                    <RideDetailsLine text={'Jus aptarnavo'} value={ride.driver.fullName} />
                    {ride?.driver?.licence && <RideDetailsLine text={'Leidimo nr.'} value={ride.driver.licence} />}
                </div>
                {ride?.clientPayment > 0 && (
                    <div className="rideDetails__buttons">
                        {user?.invoiceProps?.name ? (
                            <BaseButton
                                text={"Atsisiųsti sąskaitą"}
                                icon={downloadIcon}
                                handleOnClick={() => handleDownload(encodedId)}
                                className={'baseButton--primary baseButton--hasIconCenter'}
                            />
                        ) : (
                            <InvoiceNotice />
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default RideDetails;